module.exports = __webpack_public_path__ + "img/icon_variable.4410de3c.svg";